"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    pageCurrentOfLast: {
        id: 'pagination.pageCurrentOfLast',
        defaultMessage: 'Page {currentPage} of {lastPage}',
        description: 'Pagination Page {currentPage} of {lastPage}',
    },
    rowsPerPage: {
        id: 'pagination.rowsPerPage',
        defaultMessage: 'Rows per page',
        description: 'Pagination Rows per page',
    },
});
exports.default = messages;
